<template>
  <lk-table
      border
      :columns='columns'
      :data='resTable'
      ></lk-table>
</template>
<script>
import utils from '../../libs/utils';

export default {
  name: 'ReturnExpand',
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      columns: [
        {
          title: 'ID',
          minWidth: 58,
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '销售单号',
          minWidth: 116,
          key: 'saleOrderDetailOrderNo',
        },
        {
          title: '商品名称',
          minWidth: 116,
          key: 'saleOrderDetailGoodsName',
        },
        {
          title: '通用名称',
          minWidth: 116,
          key: 'saleOrderDetailApprovedDrugNames',
        },
        {
          title: '规格',
          minWidth: 116,
          key: 'saleOrderDetailSpecifications',
        },
        {
          title: '剂型',
          minWidth: 116,
          key: 'saleOrderDetailDosageForm',
        },
        {
          title: '单位',
          minWidth: 116,
          key: 'saleOrderDetailGoodsUnit',
        },
        {
          title: '生产企业',
          minWidth: 116,
          key: 'saleOrderDetailManufacturer',
        },
        {
          title: '上市许可持有人',
          minWidth: 116,
          key: 'mah',
        },
        {
          title: '仓库',
          minWidth: 116,
          key: 'saleRefundDetailWareHouseName',
        },
        {
          title: '货位',
          minWidth: 116,
          key: 'saleRefundDetailLocationCode',
        },
        {
          title: '数量',
          minWidth: 116,
          key: 'saleRefundDetailRefundNum',
        },
        {
          title: '产品追溯码',
          minWidth: 116,
          key: 'saleOrderDetailTraceCode',
        },
        {
          title: '退货原因',
          minWidth: 116,
          key: 'saleRefundDetailRefundReason',
        },
        {
          title: '批次',
          minWidth: 116,
          key: 'saleOrderDetailGoodsBatch',
        },
        {
          title: '单价',
          minWidth: 116,
          key: 'saleRefundDetailRefundPrice',
        },
      ],
    };
  },
  computed: {
    resTable() {
      return this.tableData.map((item) => {
        const result = {};
        utils.exchangeTable(item, result);
        return result;
      });
    },


  },
};
</script>
